import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { InputGroup } from "components/bootstrap";
const TableInfo = styled(InputGroup.Addon)`
  width: auto;
  text-align: left;
  cursor: not-allowed;
`;
const LookupTableParameterPreview = ({ parameter: { key, lookupTable } }) => {
  const { t } = useTranslation("enterprise_common");
  return /* @__PURE__ */ React.createElement(TableInfo, null, t("parameters.lookup_table_preview", { lookupTable, key }));
};
export default LookupTableParameterPreview;
